var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-user-choose"},[_c('fm-input-new',{attrs:{"size":"small","placeholder":"请输入机构名称搜索"},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}}),_c('Tree',{ref:"orgUserChoose",attrs:{"data":_vm.showNods,"show-checkbox":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }